/**
 * Firebase Web config for the super-admin panel.
 *
 * CRA inlines `process.env.REACT_APP_*` at build time and cannot resolve a
 * computed key, so every one is written out as a full literal.
 *
 * Same Firebase project as the tenant dashboards — one project serves the
 * whole platform (see PUSH_NOTIFICATION_FIREBASE_PLAN.md §20A). What differs
 * is the backend the token is registered against: /api/super/notifications/,
 * in the public schema.
 */
export const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY || '',
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN || '',
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID || '',
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET || '',
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID || '',
  appId: process.env.REACT_APP_FIREBASE_APP_ID || ''
};

/** Web Push certificate key pair from Firebase console → Cloud Messaging. */
export const vapidKey = process.env.REACT_APP_FIREBASE_VAPID_KEY || '';

/**
 * Push is opt-in per environment. Missing config is the normal state in local
 * dev and in any deploy not given Firebase credentials — every push path
 * degrades to a no-op rather than throwing.
 */
export const isPushConfigured = () =>
  Boolean(
    firebaseConfig.apiKey &&
      firebaseConfig.projectId &&
      firebaseConfig.messagingSenderId &&
      firebaseConfig.appId &&
      vapidKey
  );

/**
 * The worker is a static file in /public and cannot read process.env, so the
 * config rides on the registration URL and is read back off
 * `self.location.search`. Changing any value changes the URL, which is what
 * makes the browser pick up a new registration.
 */
export const serviceWorkerUrl = () => {
  const params = new URLSearchParams({
    apiKey: firebaseConfig.apiKey,
    authDomain: firebaseConfig.authDomain,
    projectId: firebaseConfig.projectId,
    storageBucket: firebaseConfig.storageBucket,
    messagingSenderId: firebaseConfig.messagingSenderId,
    appId: firebaseConfig.appId
  });
  return `/firebase-messaging-sw.js?${params.toString()}`;
};
